// Payroll Getters

export const getPayrollList = state => {
  return state.payrollList
}

export const getPayrollInfo = state => {
  return state.payrollInfo
}
